import React from 'react';
import styled from '@emotion/styled';

const Card = ({ children }) => (
  <CardStyled>
    {children}
  </CardStyled>
);

export const CardStyled = styled.div`
  background: #FFFFFF;
  box-shadow: 0 2px 15px 0 rgba(171,171,171,0.50);
  border-radius: 8px;
  padding: 1.25rem;
`;

export default Card;